import { render, staticRenderFns } from "./focus-words-manager.vue?vue&type=template&id=bf815f6e&scoped=true"
import script from "./focus-words-manager.ts?vue&type=script&lang=ts&external"
export * from "./focus-words-manager.ts?vue&type=script&lang=ts&external"
import style0 from "./focus-words-manager.less?vue&type=style&index=0&id=bf815f6e&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf815f6e",
  null
  
)

export default component.exports